import {CallEntity} from "./call-entity";

export interface CallSessionUpdate {

    id: string;

    call_id: string;

    installation_id: string;

    state: CallSessionUpdateState;

    entity: CallEntity;

    peer_id?: string;

}

export enum CallSessionUpdateState {
    Started = 'started',
    Bridged = 'bridged',
    Pending = 'pending',
    Answered = 'answered',
    Hold = 'hold',
    Closed = 'closed'
}
